import { doc, setDoc } from "firebase/firestore";
import { ORDER_FAIL, ORDER_REQUEST, ORDER_SUCCESS } from "../constants/orderConstants";
import { db } from "../firebase.config";
import { supabase } from "../supabase.config";
import { emitOrderNotification } from "../utils/notificationService";

export const saveOrder = (data, orderId) => async (dispatch) => {
  try {


    dispatch({ type: ORDER_REQUEST });
    console.log(data)
    await setDoc(doc(db, "logisticOrder", orderId), data).then(async (res) => {


      dispatch({ type: ORDER_SUCCESS, payload: data });

    }).catch((err) => {
      alert(err.message)
      dispatch({
        type: ORDER_FAIL,
        payload: err.message,
      });
    })

  } catch (err) {
    alert(err.message)
    dispatch({
      type: ORDER_FAIL,
      payload: err.message,
    });
  }
}

// Supabase version: maps app order to Supabase orders schema
export const saveOrderSupabase = (data) => async (dispatch) => {
  try {
    dispatch({ type: ORDER_REQUEST });

    const { data: authData } = await supabase.auth.getUser()
    const authUid = authData?.user?.id || null

    // Map fields
    const payload = {
      user_id: data?.uid || null,
      order_id: data?.orderID || null,
      order_number: data?.lrno || data?.orderID || null,
      pickup_address: JSON.stringify(data?.pickup_location || {}),
      delivery_address: JSON.stringify(data?.dropoff_location || {}),
      pickup_contact: data?.pickup_location?.phone || null,
      delivery_contact: data?.dropoff_location?.phone || null,
      package_details: JSON.stringify({
        invoices: data?.invoices,
        suborders: data?.suborders,
        orderActivity: data?.orderActivity,
        cb: data?.cb,
        totalqty: data?.totalqty,
        rov_insurance: data?.rov_insurance,
        payment_mode: data?.payment_mode,
        d_mode: data?.d_mode,
        purchaseCharge: data?.purchaseCharge,
        salesCharge: data?.salesCharge,
        masterAWB: data?.masterAWB,
        userName: data?.userName,
        deliveryactualdate: data?.deliveryactualdate,
        shipping_type: data?.shippingType || null
      }),
      weight: data?.weight || null,
      dimensions: JSON.stringify(data?.dimensions || []),
      shipping_partner: null,
      tracking_number: data?.lrno || null,
      status: data?.orderStatus || 'pending',
      total_amount: data?.salesCharge || null
    }

    if (data?.createdAt) {
      payload.created_at = new Date(data.createdAt).toISOString()
    }
    
    

    const { data: inserted, error } = await supabase
      .from('orders')
      .insert([payload])
      .select()

    if (error) {
      dispatch({ type: ORDER_FAIL, payload: error.message })
      return Promise.reject(error)
    }

    const savedOrder = inserted?.[0] || payload

    await emitOrderNotification({
      actorUserId: authUid,
      order: savedOrder,
      eventType: "order_created",
      title: "New order created",
      message: `Order ${savedOrder?.tracking_number || savedOrder?.order_number || savedOrder?.order_id || ""} was created.`,
      metadata: {
        status: savedOrder?.status || payload.status,
      },
    })

    dispatch({ type: ORDER_SUCCESS, payload: savedOrder })
    return savedOrder
  } catch (err) {
    dispatch({ type: ORDER_FAIL, payload: err.message })
    return Promise.reject(err)
  }
}
